<template>
  <b-navbar
    class="navbar-container d-flex justify-content-between align-items-center rounded bg-gradient rounded-xl"
  >
    <b-navbar-nav class="p-1" v-if="Object.keys(this.userData).length == 0">
      <b-img
        width="80"
        :src="require('@/assets/images/fxlegends/logo2.png')"
      ></b-img>
    </b-navbar-nav>
    <b-navbar-nav
      class="ml-auto p-1"
      v-if="Object.keys(this.userData).length == 0"
    >
      <b-button class="gradient-btn" to="/login">login</b-button>
    </b-navbar-nav>
    <b-navbar-nav
      class="d-xl-none d-inline"
      v-if="Object.keys(this.userData).length && !$route.fullPath.includes('partner-registration')"
    >
      <b-link class="text-white" @click="toggleVerticalMenuActive">
        <feather-icon icon="MenuIcon" size="21" />
      </b-link>
    </b-navbar-nav>
    <b-navbar-nav
      class="d-xl-none d-inline"
      v-if="Object.keys(this.userData).length"
    >
      <b-img
        width="80"
        :src="require('@/assets/images/fxlegends/logo2.png')"
      ></b-img>
    </b-navbar-nav>

    <!-- Left Col -->

    <b-navbar-nav class="  " v-if="Object.keys(this.userData).length">
      <div class="w-100 d-flex align-items-center">
        <user-dropdown />
      </div>
    </b-navbar-nav>
    <b-navbar-nav
      class="d-xl-inline d-none"
      v-if="Object.keys(this.userData).length"
    >
      <div class="w-100 d-flex align-items-center">
        <div class="ml-auto">
          <notification-slide />
        </div>
      </div>
    </b-navbar-nav>
  </b-navbar>
</template>

<script>
import { BLink, BNavbarNav, BImg, BNavbar, BButton } from "bootstrap-vue";
import SearchBar from "./components/SearchBar.vue";
import DarkToggler from "./components/DarkToggler.vue";
import CartDropdown from "./components/CartDropdown.vue";
import NotificationDropdown from "./components/NotificationDropdown.vue";
import NotificationSlide from "./components/NotificationSlide.vue";
import UserDropdown from "./components/UserDropdown.vue";

export default {
  components: {
    BLink,
    BImg,
    BNavbar,
    // Navbar Components
    BNavbarNav,
    BButton,
    SearchBar,
    DarkToggler,
    CartDropdown,
    NotificationDropdown,
    NotificationSlide,
    UserDropdown,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    userData() {
      return (
        this.$store.state.auth.userData ||
        JSON.parse(localStorage.getItem("userData"))
      );
    },
  },
};
</script>
<style scoped>
.bg-gradient {
  background: rgb(250, 75, 104);
  background: linear-gradient(
    110deg,
    rgba(250, 75, 104, 0.0959734235491071) 0%,
    rgba(250, 97, 89, 0) 22%,
    rgba(250, 123, 71, 0) 75%,
    rgba(251, 173, 37, 0.07916670086003152) 100%
  );
}
</style>
